export default {"src":"/_next/static/media/dot-pattern.5b417b95.svg","height":319,"width":103,"blurWidth":0,"blurHeight":0};